import React, { useContext } from "react";
import Badge from "./Badge";
import { BiLinkAlt, BiVideo } from "react-icons/bi";
import { DiGithubAlt } from "react-icons/di";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AnimationContext from "../contexts/animation/AnimationContext";
function Project({
  title,
  imageUrl,
  liveUrl,
  videoUrl,
  setVideoModal,
  githubUrl,
  scale,
  techStack,
  slug,
  inView,
}) {
  const { setAnimation } = useContext(AnimationContext);
  const inViewVariants = setAnimation(inView);
  return (
    <motion.div
      variants={inViewVariants}
      initial="hidden"
      animate="visible"
      className="flex-shrink-0 flex-grow-0 "
    >
      <div className=" bg-scColor/20 overflow-hidden relative z-0">
        <img
          src={imageUrl}
          loading="lazy"
          alt="project"
          className="pt-10 pl-10 pr-10 sm:pt-16 sm:pl-16 sm:pr-16  md:pt-20 md:pl-20 md:pr-20 lg:pt-28 lg:pl-28 lg:pr-28 w-full h-[20rem] sm:h-[24rem] object-cover object-top hover:object-bottom transition-all duration-[8000ms] ease-linear cursor-move"
        />
        <div
          className={`absolute top-[-2rem] xs:top-[4.8rem] md:top-[-4rem] lg:top-[2rem] xl:top-[3rem] left-0 w-full h-full bg-contain bg-top bg-no-repeat bg-blend-overlay before:bg-scColor/80 z-[-1] before:absolute before:content-[''] before:w-full before:h-full`}
          style={{
            backgroundImage: `url(${imageUrl})`,
            transform: `scale(${scale}) rotate(-45deg) translateX(-0.9rem)`,
          }}
        ></div>
      </div>
      <div className=" mt-12">
        <div className="flex justify-between items-center gap-3 flex-wrap">
          <Link
            to={`/${slug}`}
            className="text-light hover:text-dark focus:text-dark focus:outline-light transition-colors duration-300 text-[1.35rem] md:text-3xl font-['Poppins'] font-semibold"
          >
            {title}
          </Link>
          <div className="flex items-center gap-2">
            {liveUrl && (
              <a
                href={liveUrl}
                target={"_blank"}
                rel="noreferrer"
                title="Go Live"
              >
                <BiLinkAlt className="text-dark focus:text-dark focus:outline-light text-3xl transition-colors duration-300 hover:text-light" />
              </a>
            )}
            {!liveUrl && (
              <button
                title="See Video"
                onClick={() => setVideoModal({ isOpen: true, url: videoUrl })}
              >
                <BiVideo className="text-dark focus:text-dark focus:outline-light text-3xl transition-colors duration-300 hover:text-light cursor-pointer" />
              </button>
            )}
            <a
              href={githubUrl}
              target={"_blank"}
              rel="noreferrer"
              title="Source Code"
            >
              <DiGithubAlt className="text-dark focus:text-light focus:border-light text-3xl transition-colors duration-300 hover:text-light" />
            </a>
          </div>
        </div>

        <div className="mt-8 flex items-center gap-4 flex-wrap mb-8">
          {techStack.map((tech, index) => (
            <Badge key={index} skill={tech.attributes.name} />
          ))}
        </div>
      </div>
    </motion.div>
  );
}
export default Project;
